var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckThick = function SvgCheckThick(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 13.4 10",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 9.8.2 5.4c-.3-.3-.3-.7 0-.9l.9-.9c.3-.3.7-.3.9 0l3 2.9L11.3.2c.3-.3.7-.3.9 0l.9.9c.3.3.3.7 0 .9L5.5 9.8c-.3.3-.7.3-.9 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckThick);
export default ForwardRef;